module.exports = "<div class=\"loading\">\n  <img src=\"img/loading-bbva.gif\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/loading/loading.html
// module id = 736
// module chunks = 0